import Env from "../base/env";
import gsap from "gsap";
import easesCustom from "../fx/CustomEases";

export default class MainTransition {
  constructor() {
    this.DOM = {};
    this.DOM.view = Env.$mainTransition;
    this.DOM.progress = Env.$mainTransitionProgress;
    this.DOM.text = this.DOM.view.querySelector(".fxText");
    this.settings = { easing: "cubic.inOut", duration: 0.5 };
    this.direction = false;
    this.status = false;
    this.setDirection(-1);
  }

  getStatus() {
    return this.status;
  }

  out(funcStart = "", funcComplete = "") {
    let timeline = gsap.timeline({
      onStart: () => {
        this.status = "animating";
        if (typeof funcStart == "function" || funcStart != null) funcStart();
      },
      onComplete: () => {
        this.status = "in";
        if (typeof funcComplete == "function" || funcComplete != null)
          funcComplete();
      },
    });

    timeline.add([
      gsap.fromTo(
        this.DOM.view,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          duration: this.settings.duration,
          ease: this.settings.easing,
          delay: 0,
        }
      ),
    ]);
    timeline.timeScale(1.6);
  }

  in(funcStart = "", funcComplete = "") {
    let timeline = gsap.timeline({
      onStart: () => {
        this.status = "animating";
        if (typeof funcStart == "function" || funcStart != null) funcStart();
      },
      onComplete: () => {
        this.status = "out";
        if (typeof funcComplete == "function" || funcComplete != null)
          funcComplete();
      },
    });
    timeline
      .add([
        gsap.fromTo(
          this.DOM.progress,
          {
            x: 0,
          },
          {
            x: "100%",
            duration: 0.8,
            ease: "cubic.inOut",
          },
          gsap.fromTo(
            this.DOM.text,
            {
              y: 150,
            },
            {
              y: 0,
              ease: easesCustom.quart,
              duration: 1.2,
            }
          )
        ),
      ])
      .add(
        [
          gsap.to(this.DOM.text, {
            y: 150,
            ease: "quint.inOut",
            duration: 1.2,
            delay: 0.4,
          }),
          gsap.fromTo(
            this.DOM.progress,
            {
              x: "-100%",
            },
            {
              immediateRender: false,
              x: 0,
              duration: 1.2,
              ease: "cubic.inOut",
            }
          ),
        ],
        "+=.5"
      )
      .add([
        gsap.fromTo(
          this.DOM.view,
          {
            autoAlpha: 1,
          },
          {
            immediateRender: false,
            autoAlpha: 0,
            ease: this.settings.easing,
            delay: 0,
          }
        ),
      ]);
    timeline.timeScale(1.6);
  }

  setTitle(text) {
    this.DOM.text.innerHTML = text;
  }

  setDirection(value) {
    this.direction = value;
  }

  setTransitionViewVisibleNoTween() {
    gsap.set(this.DOM.view, {
      autoAlpha: 1,
      duration: 0.1,
    });
  }

  setTransitionViewVisible() {
    gsap.to(
      this.DOM.view,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.1,
      }
    );
  }
}
